import { useCallback, useEffect, useState } from 'react';
import { Mail, Calendar as CalIcon } from 'lucide-react';
import { useAgent } from '../hooks/useAgent';

export default function CalendarTab() {
  const { listAccounts, calStatus, calConnect, calDisconnect } = useAgent();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setError(null);
    try {
      const list = await listAccounts();
      const withStatus = await Promise.all((list || []).map(async (a) => {
        const st = await calStatus(a.id).catch(() => ({ connected: false }));
        return { id: a.id, email: a.email || a.smtp_username, ...st };
      }));
      setRows(withStatus);
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    }
  }, [listAccounts, calStatus]);

  useEffect(() => { load(); }, [load]);

  if (error) return <div className="agent-empty">{error}</div>;
  if (!rows) return <div className="agent-loading">Loading…</div>;
  if (rows.length === 0) return <div className="agent-empty">No email accounts yet. Add one first.</div>;

  const disconnect = async (id) => { await calDisconnect(id); load(); };

  return (
    <div className="agent-section">
      <p className="agent-tab-intro">
        Connect a Google Calendar per mailbox so the agent can propose real times and book meetings.
      </p>
      {rows.map((r) => (
        <div key={r.id} className="agent-row">
          <div className="agent-acct">
            <div className="agent-acct-icon"><Mail size={18} /></div>
            <div>
              <div className="agent-acct-email">{r.email}</div>
              <div className={`agent-status ${r.connected ? 'ok' : 'off'}`}>
                <span className="agent-status-dot" />
                {r.connected ? `Connected · ${r.google_email}` : 'Not connected'}
              </div>
            </div>
          </div>
          {r.connected
            ? <button className="agent-btn" onClick={() => disconnect(r.id)}>Disconnect</button>
            : (
              <button className="agent-btn primary" onClick={() => calConnect(r.id)}>
                <CalIcon size={15} style={{ verticalAlign: '-2px', marginRight: 6 }} />
                Connect Google
              </button>
            )}
        </div>
      ))}
    </div>
  );
}
